import basePageStyle from "./BasePage.module.css";
import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../Home/Home";
import Gallery from "../Gallery/Gallery";
import ContactUs from "../ContactUs/ContactUs";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";
import SocialIcons from "../../components/SocialIcons/SocialIcons";
import { useEffect } from "react";
import Service from "../Services/Service";
import Career from "../Career/Career";
import Registration from "../Registration/Registration";
import Review from "../Review/Review";
import AboutUs from "../CompanyProfile/AboutUs/AboutUs";
import Blog from "../Blog/Blog";
import BlogDetailed from "../Blog/BlogDetailed";
// import Certificates from "../Certificates/Certificates";
import WhyUs from "../CompanyProfile/WhyUs/WhyUs";
import MissionVision from "../CompanyProfile/MissionVision/MissionVision";
import Certificates from "../Certificates/Certificates";
import News from "../News/News";
import NewsDetailed from "../News/NewsDetailed";
import SocialIconDetails from "../SocialIconDetails";
import RequestCallback from "../RequestCallback/RequestCallback";
import GlobalPresence from "../GlobalPresence/GlobalPresence";
import Event from "../Event/Event";
import EventDetailed from "../Event/EventDetailed";
import ResearchAndDevelopment from "../R&D/ResearchAndDevelopment";
import Product from "../Product/Product";
import ProductDetail from "../Product/ProductDetail";

const BasePage = () => {
  /* Added by Jhamman on 27-09-2024
  Reason - remove pageFrame background from homepage*/
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);
  /* End of addition by Jhamman on 27-09-2024
  Reason - remove pageFrame background from homepage*/

  return (
    <div
      className={`${basePageStyle.pageFrame}`}
     
      style={currentPath.endsWith("/") ? { backgroundImage: "none" } : {}}>
      <div className={`${basePageStyle.pageContainer}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          
          
          <Route
            path="/company_profile/mission-vision"
            element={<MissionVision />}
          />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog_detailed" element={<BlogDetailed />} />
          <Route path="/socialicons" element={<SocialIconDetails />} />

          <Route path="/news" element={<News />} />
          <Route path="/news_detailed" element={<NewsDetailed />} />
          {/* <Route path="/certificates" element={<Certificates />} /> */}
          <Route path="/company_profile/why-us" element={<WhyUs />} />

          <Route path="/gallery" element={<Gallery />} />
         
          <Route path="/contact/india" element={<ContactUs />} />
          <Route path="/contact/uk" element={<ContactUs />} />
          <Route path="/contact/us" element={<ContactUs />} />
          <Route path="/contact/newzealand" element={<ContactUs />} />


          <Route path="/career" element={<Career />} />

          <Route path="/certificates" element={<Certificates />} />
          
          <Route path="/services" element={<Service />} />

          <Route path="/client_testimonials" element={<Review />} />
          <Route path="/company_profile/about_us" element={<AboutUs />} />

          <Route path="/registration" element={<Registration/>} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

         
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
        {/* Added by - Ashlekh on 04-02-2025
        Reason - To add route for global presence page */}
        <Route path="/global-presence" element={<GlobalPresence />} />
        {/* End of code - Ashlekh on 04-02-2025
        Reason - To add route for global presence page */}
        {/* Added by - Ashlekh on 04-02-2025
        Reason - To add route for event page */}
        <Route path="/event" element={<Event />} />
        <Route path="/event_detailed" element={<EventDetailed />} />
        {/* End of code - Ashlekh on 04-02-2025
        Reason - To add route for event page */}
        {/* Added by - Ashlekh on 13-02-2025
        Reason - To add route for R&D page */}
        <Route path="/research-and-development" element={<ResearchAndDevelopment />} />
        {/* End of code - Ashlekh on 13-02-2025
        Reason - To add route for R&D page */}

        {/* Added by - Sameer on 07-11-2025
        Reason - To add route for product and product detail page */}
        <Route path="/products" element={<Product />} />
        <Route path="/product_detail" element={<ProductDetail />} />
        {/* End of code - Sameer on 07-11-2025
        Reason - To add route for product and product detail page */}
        </Routes>
      </div>

      {/* Added by - Ashlekh on 03-02-2025
      Reason - To add RequestCallback */}
      <RequestCallback/>
      {/* End of code - Ashlekh on 03-02-2025
      Reason - To add RequestCallback */}
      <SocialIcons />
     
    </div>
  );
};

export default BasePage;
